const esLang = {
  readMore: 'Leer más',
  nextBlock: 'Siguiente sección: ',
  missionBlock: 'Mejorando vidas',
  blogBlock: 'Sanfer global',
  businessBlock: 'áreas de negocio',
  foundationBlock: 'Fundación sanfer',
  globalBlock: 'Grupo Sanfer',
  featured: 'Destacado',
  knowMore: 'Conocer más',
  operation: 'Operaciones',
  worldwide: 'Presencia Sanfer',
  sanferGroup: 'Grupo Sanfer',
  blogBtn: 'Visita la sección Comprometidos con tu salud.',
}
const enLang = {
  readMore: 'Leer más',
  knowMore: 'Conocer más',
  nextBlock: 'Siguiente sección: ',
  missionBlock: 'Mejorando vidas',
  blogBlock: 'Sanfer global',
  businessBlock: 'áreas de negocio',
  foundationBlock: 'Fundación sanfer',
  globalBlock: 'Grupo Sanfer',
  featured: 'Destacado',
  operation: 'Operaciones',
  worldwide: 'Presencia Sanfer',
  sanferGroup: 'Grupo Sanfer',
  blogBtn: 'Visita la sección Comprometidos con tu salud.',
}

export const langTexts = {
  es: esLang,
  en: enLang
}